@if (thumbnailUrl(); as url) {
	<span
		[tuiAvatar]="icon()"
		class="content-thumbnail__avatar"
		[size]="size()"
		[round]="false"
	>
		<img [src]="url" alt="" />
	</span>
} @else {
	<span
		[tuiAvatar]="icon()"
		class="content-thumbnail__avatar"
		[size]="size()"
		[round]="false"
	></span>
}

@if (badgeIcon()) {
	<span
		[tuiAvatar]="badgeIcon()"
		class="content-thumbnail__badge"
		size="s"
		tuiHintAppearance="dark"
		[tuiHint]="badgeHint()"
	></span>
}
